import { PropertyBaseKey } from '../event-panel/event-panel-form/involved-person-vehicle-fields/types';

export const propertiesBaseKey: readonly PropertyBaseKey[] = [
    'firearms',
    'mergedFirearms',
    'drugs',
    'mergedDrugs',
    'otherItems',
    'mergedOtherItems',
];
